import { Base } from "ui/Scripts/source/framework/base";
import { IListItems, ListItems } from "ui/Scripts/source/framework/listItems";
import { IMessageListItem, MessageListItem } from "./messageListItem";

export interface IMessageListItems extends IListItems<IMessageListItem> {}

export class MessageListItems extends ListItems<MessageListItem> implements IMessageListItems {
    constructor();
    constructor(obj: IMessageListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, MessageListItem);
    }
}